import { Component, Inject, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from "@angular/material/dialog"
import { DeleteModalData } from "./delete-modal.model"

@Component({
  selector: 'tr-delete-modal',
  templateUrl: 'delete-modal.component.html',
  styleUrls: ['delete-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TrDeleteModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DeleteModalData) {}
}
